export default "__VITE_PUBLIC_ASSET__52819b3f__"